var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaveFiling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1484_4368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9248 27.1328H19.6865C19.0107 27.1328 18.4629 27.6806 18.4629 28.3564V36.9239C18.4629 37.5997 19.0107 38.1475 19.6865 38.1475H31.9248C32.6005 38.1475 33.1484 37.5997 33.1484 36.9239V28.3564C33.1484 27.6806 32.6005 27.1328 31.9248 27.1328Z",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4629 32.0283H33.1484",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8057 32.0283V33.8637",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8853 24.6846C27.3489 24.6846 27.7722 24.9468 27.9797 25.361L28.8658 27.1318H22.7471L23.6332 25.361C23.8407 24.9468 24.264 24.6846 24.7276 24.6846H26.8868H26.8853Z",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1193 18.5667C13.4849 18.5667 15.4027 16.649 15.4027 14.2834C15.4027 11.9177 13.4849 10 11.1193 10C8.75366 10 6.83594 11.9177 6.83594 14.2834C6.83594 16.649 8.75366 18.5667 11.1193 18.5667Z",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9571 24.6854C15.944 21.4615 12.5088 19.6694 9.28488 20.6825C6.73432 21.4843 5 23.8479 5 26.5216V30.8049H8.05976L8.67156 38.1481H13.5667L14.1785 30.8049H15.4021",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1484_4368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveFiling);
export default __webpack_public_path__ + "static/media/leave-filing.9ee3e896177dafcc36898ec5e01386ed.svg";
export { ForwardRef as ReactComponent };